<template>
  <div>
    <div
      class="alert alert-warning border-0 text-center mt-1 align-items-center justify-content-center position-relative"
      role="alert"
      v-show="closeModal"
    >
      <i class="material-icons pr-2" style="font-size: 3em">info</i>
      <p style="text-align: center">PÁGINA EM MANUTENÇÃO!</p>
      <br />
      <p style="text-align: center">
        Estamos trabalhando para resolvermos o mais breve possível.
      </p>
      <br />
      <p style="text-align: center">
        Para solicitações, entre em contato conosco através dos canais abaixo:
      </p>
      <p style="text-align: center">- Telefone: (31) 3249-1666</p>
      <p style="text-align: center">- WhatsApp: (31) 3249-1666</p>
      <p style="text-align: center">- E-mail: relacionamento@cdlbh.com.br</p>
      <p style="text-align: center">- Chat: cdlbh.com.br</p>
      <p style="text-align: center">
        Nosso horário de funcionamento é das 8h às 19h, de segunda à sexta e de
        08h às 14h aos sábados e feriados.
      </p>
    </div>
    <form
      class="form_padrao pt-2"
      action
      @submit.prevent="abrirChamado"
      v-show="statusManutencao"
    >
      <div class="form-row">
        <div class="form-group flutuante col-md-12">
          <input
            type="text"
            name="nomeOperador"
            id="nomeOperador"
            required
            v-model="operador.nome"
          />
          <label for="nomeOperador">Nome do Beneficiário</label>
        </div>
        <div class="form-group flutuante col-md-6">
          <the-mask
            type="text"
            name="cpf"
            id="cpf"
            v-model="operador.cpf"
            required
            :mask="['###.###.###-##']"
          />
          <label for="cpf">CPF</label>
        </div>
        <div class="form-group flutuante col-md-6">
          <select
            name="movimentacaoTipo"
            id="movimentacaoTipo"
            v-model="operador.operadora"
            placeholder="Selecione"
          >
            <option value selected disabled>Selecione...</option>
            <option value="201">Unimed</option>
            <option value="1075">Premium Saúde</option>
            <option value="202">Vitallis</option>
          </select>
          <label for="movimentacaoTipo" v-if="!operador.operadora"
            >Operadora</label
          >
        </div>
        <div class="form-group flutuante col-md-6">
          <input
            type="email"
            name="emailContato"
            id="emailContato"
            v-model="operador.email"
            required
          />
          <label for="emailContato">E-mail de Contato</label>
        </div>
        <div class="form-group flutuante col-md-6">
          <the-mask
            type="text"
            name="telefoneContato"
            id="telefoneContato"
            required
            :mask="['(##) ####-####', '(##) #####-####']"
            v-model="operador.telefone"
          />
          <label for="telefoneContato">Telefone</label>
        </div>
      </div>
      <div class="form-row">
        <div
          class="form-group col-md-3 d-flex flex-row justify-content-end align-items-end"
        >
          <button
            type="submit"
            class="btn btn-verde p-0 fit-content"
            :disabled="loading"
          >
            <span
              class="spinner-grow spinner-grow-sm pr-2"
              role="status"
              aria-hidden="true"
              v-show="loading"
            ></span>
            <span v-if="loading">Enviando</span>
            <span v-else>enviar Solicitação</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
export default {
  name: "carta-carencia",
  components: {
    TheMask,
  },
  data() {
    return {
      produto: {
        nome: "Carta Carência",
        id: "Carteirinha",
      },
      loading: false,
      closeModal: true,
      statusManutencao: false,
      operador: {
        nome: null,
        email: null,
        telefone: null,
        cpf: null,
        operadora: null,
      },
    };
  },
  methods: {
    abrirChamado() {
      this.loading = true;
      this.$http
        .post("/api/Ssm/RegistrarChamadoServicos", {
          idItemDeCatalogo: parseInt(this.operador.operadora),
          motivo: `Nome: ${this.operador.nome}-Email: ${this.operador.email}-Telefone: ${this.operador.telefone}-CPF: ${this.operador.cpf}`,
        })
        .then((response) => {
          this.loading = false;
          this.$toast.open({
            message: response.data.message,
            type: "success",
          });
          this.operador = {};
        })
        .catch(() => {
          this.loading = false;
          this.$toast.open({
            message: "Erro no envio da solicitação, tente novamente.",
            type: "error",
          });
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },
};
</script>

<style lang="scss" scoped></style>
